module.exports = __webpack_public_path__ + "static/weretiger-bda34f51608ca50814b6eea50fb1045d.jpg";